import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext, PreferenceContext } from '../context';
import { useNavigate } from 'react-router-dom';
import { RefreshIcon, SettingsIcon, NsfwIcon } from 'icons';
import { SettingsMenu } from '../menus';
import { gaEvent } from 'services/ga';
import { Button } from '../button';
import { MediaFilter } from './';

export const Filter = ({ showReload = false, isRight }) => {
  const navigate = useNavigate();
  const { setSlideIn, windowSize } = useContext(AppContext);
  const {
    preference: { filter, nsfwActive },
    setPreference,
  } = useContext(PreferenceContext);

  return (
    <div tw='flex-col'>
      <div tw='flex justify-center items-center gap-3'>
        {showReload && (
          <Button
            label='Herladen'
            iconProps={{ Type: RefreshIcon }}
            onClick={() => navigate(0)}
            noSpacing
          />
        )}
        {filter && filter !== '' && (
          <MediaFilter hideLabel={['MOBILE'].includes(windowSize.adBreakPoint)} isRight={isRight} />
        )}
        <Button
          label='instellingen'
          iconProps={{ Type: SettingsIcon, size: 'medium' }}
          hideLabel={['MOBILE'].includes(windowSize.adBreakPoint)}
          onClick={() =>
            setSlideIn({
              active: true,
              fullwidth: false,
              Component: () => <SettingsMenu />,
            })
          }
          noSpacing
        />
        <Button
          label='nsfw'
          iconProps={{ Type: NsfwIcon, color: nsfwActive ? 'success' : 'icons' }}
          hideLabel={['MOBILE'].includes(windowSize.adBreakPoint)}
          onClick={() => {
            setPreference({ nsfwActive: !nsfwActive });
            gaEvent('dmp_settings_change', `nsfw_${!nsfwActive}`);
            navigate(0);
          }}
        />
      </div>
    </div>
  );
};
